module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-81.93ce1f5.woff2";